import * as React from 'react'
import { isEmpty } from 'lodash'
import styled from 'styled-components'

import { Tag, TagCloseButton, TagLabel } from '~/components'
import { useFilters } from '~/hooks/use-filters'
import { useFiltersState } from '~/hooks/use-filters-state'
import { IProductFilterType } from '~/types/product-filters'

import { deserializeFilterValues } from '../filters-provider/filters-serialize'

export interface SelectedFilterTagsProps {
  className?: string
}

const StyledSelectedFilterTagsContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: ${props => props.theme.spacing.cozy}px;
`

export function SelectedFilterTags(props: SelectedFilterTagsProps) {
  const { className } = props

  const { toggleListFilterValue, setRangeFilter } = useFiltersState()

  const { selectedTags } = useFilters()

  if (isEmpty(selectedTags)) {
    return null
  }

  return (
    <StyledSelectedFilterTagsContainer className={className}>
      {selectedTags.map(selected => {
        return (
          <Tag key={`selected-filter-tag-${selected.serializedFilter}`}>
            <TagLabel>{selected.label}</TagLabel>
            <TagCloseButton
              onClick={() => {
                if (selected.type === IProductFilterType.LIST) {
                  toggleListFilterValue(selected.serializedFilter)
                } else {
                  const { target } = deserializeFilterValues(selected.serializedFilter)

                  setRangeFilter(target, null, null)
                }
              }}
            />
          </Tag>
        )
      })}
    </StyledSelectedFilterTagsContainer>
  )
}
